import { filter, includes, equals, isEmpty, or as hasTrue } from 'ramda';
import { getProperty as dotProp } from 'dot-prop';

const isObject = obj => Object.prototype.toString.call(obj) === '[object Object]';

const isHidden = (data) => {
  const {
    details,
    hiddenTrigger,
  } = data;

  if (!hiddenTrigger) {
    return false;
  }

  const findMatches = (triggerType = []) => filter((condition) => {
    const {
      path: hiddenTriggerPath,
      pathValue: hiddenTriggerPathValue,
    } = condition;

    const dataValue = dotProp(details, hiddenTriggerPath);

    if (isObject(dataValue)) {
      return equals(dataValue, hiddenTriggerPathValue);
    }

    if (Array.isArray(dataValue)) {
      return Array.isArray(dataValue) && dataValue.length === hiddenTriggerPathValue.length;
    }

    return includes(
      dataValue,
      hiddenTriggerPathValue,
    );
  })(triggerType);

  return hasTrue(
    equals(findMatches(hiddenTrigger.and), hiddenTrigger.and),
    !isEmpty(findMatches(hiddenTrigger.or)),
  );
};

export default isHidden;
